import React, { useState, useEffect } from 'react';
import { Drawer, Button, Select, message, Spin, Input, Form,Checkbox } from 'antd';
import FiltersDynamic from '../Components/FiltersDynamicComponent';
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';

const { Option } = Select;

const GetNodeFlowDrawer = ({isEditingMode,selectedNode, visible, onClose, nodeData, onSave }) => {
  const [objects, setObjects] = useState([]);
  const [fields, setFields] = useState([]);
  const [selectedObject, setSelectedObject] = useState(null);
  const [filters, setFilters] = useState([]);
  const [logic, setLogic] = useState('');
  const [valueOperator, setValueOperator] = useState('');
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [apiName, setApiName] = useState('');
  const [description, setDescription] = useState('');
  const [isSingleRecord,setIsSingleRecord] = useState(true);
  useEffect(() => {
    if (visible) {
      fetchObjects();
    }
  }, [visible]);


  useEffect(() => {
    if (nodeData && Object.keys(nodeData).length > 0) {
        console.log('nodedata:::',nodeData);
      // Set basic details
      setName(nodeData?.label ? nodeData?.label : nodeData?.name || "");
      setApiName(nodeData?.apiName ? nodeData?.apiName : nodeData?.name || "");
      setDescription(nodeData?.description || "");
      setSelectedObject(nodeData?.parameters?.model || null);
      setIsSingleRecord(nodeData?.parameters?.is_single_record);
      // Set logic
      setLogic(nodeData?.parameters?.logic_string || "");
  
      // Set conditions (filters)
      const existingFilters = nodeData?.parameters?.conditions
        ? Object.entries(nodeData?.parameters?.conditions).map(([key, { field, value }]) => {
          let operator = '';
          let actualValue = '';
          if (Object.keys(value)[0] !== "0") {
            operator = Object.keys(value)[0];
            actualValue = value[operator];
          } else {
            actualValue = value; // Extract the actual value (e.g., '50')
          }
          let op = '';
          if (operator !== '') {
            try {
              setValueOperator(operator);
              op = operator;
            } catch (error) {
              // Handle the error gracefully
              setValueOperator(''); // or any default value
            }
          } else {
            op = '';
          }
          return {
            field,
            value: value,
            displayValue: actualValue,
            operator: op
          };
        })
        : [{ field: '', value: '', operator: '' }];
        setFilters(existingFilters); // Set filters state here
  
      // Set value operator if applicable
      if (existingFilters.length > 0 && existingFilters[0].operator) {
        setValueOperator(existingFilters[0].operator);
      } else {
        setValueOperator("");
      }
  
      // Fetch fields for the selected object if available
      if (nodeData.parameters?.model) {
        fetchFields(nodeData.parameters.model);
      }
    }
      else {
        // Reset all states if nodeData is empty or null
        setName('');
        setApiName('');
        setDescription('');
        setSelectedObject(null);
        setLogic('');
        setFilters([]);
      }
    }, [visible]);
  

  const fetchObjects = async () => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_objects`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setObjects(response);
    } catch (error) {
      console.error('Error fetching objects:', error);
      message.error('Failed to fetch objects.');
    } finally {
      setLoading(false);
    }
  };

  const fetchFields = async (objName) => {
    try {
      setLoading(true);
      const apiService = new ApiService(`${BASE_URL}/mt_fields/object/${objName}`, { 'Content-Type': 'application/json' }, 'GET');
      const response = await apiService.makeCall();
      setFields(response);
    } catch (error) {
      console.error('Error fetching fields:', error);
      message.error('Failed to fetch fields.');
    } finally {
      setLoading(false);
    }
  };

  const handleObjectChange = (value) => {
    setSelectedObject(value);
    fetchFields(value);
    setFilters([]); // Reset the filters to an empty array
    setLogic(''); // Optionally reset the logic as well
    setValueOperator(''); // Optionally reset the value operator if needed
  };
  
  const handleSave = () => {
    if (!name || !apiName || !selectedObject) {
      message.error('Please fill all required fields.');
      return;
    }

    const filterObj = filters.reduce((acc, filter, index) => {
      if (filter.field) {
        acc[index + 1] = {
          field: filter.field,
          value: filter.value
        }; 
      }
      return acc;
    }, {});

   
    const type = 'get_query';
    
    // const params = {
    //     model: selectedObject || "",
    //     logic_string: logic || "1",
    //     conditions: Object.values(filterObj || {}).map((filter) => {
    //         const valueObj = filter.value || {};
    //         const actualValue = Object.values(valueObj)[0] || "";
    //         console.log('act value::',actualValue);
    //         console.log('act value::',actualValue);
    //         return {
    //         field: filter.field || "",
    //         value: actualValue
    //         };
    //     }),
    //     };
    const params = {
        model: selectedObject || "",
        logic_string: logic || "1",
        conditions: filterObj, // no .map with transformation here
        is_single_record: isSingleRecord

      };
    
    
    const data = {
        name,
        apiName,
        description,
        type,
        parameters: {
            ...params
        },
    };
      
    console.log('data::',data);  
    const message = onSave(selectedNode.id,data);
    // message.success('Filters saved successfully!');
    // onClose();
  };

  return (
    <Drawer
      title={`Get Records`}
      placement="right"
      onClose={onClose}
      visible={visible}
      mask={false}
      zIndex={1002}   // higher than sidebar
      width={600}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button type="default" onClick={onClose}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleSave}>
            Save
          </Button>
        </div>
      }
      footerStyle={{ textAlign: 'right' }}
    >
      {loading ? (
        <Spin tip="Loading..." />
      ) : (
        <Form layout="vertical">
          <Form.Item label="Name" required>
            <Input
              placeholder="Enter name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onBlur={() => {
                if (name) {
                  setApiName(
                    name
                      .replace(/[^a-zA-Z0-9]/g, "") // Remove special characters
                      .replace(/\s+/g, "") // Remove spaces
                      .trim()
                  );
                }
              }}          
            />
          </Form.Item>

          <Form.Item label="API Name" required>
            <Input
              placeholder="Enter API name"
              value={apiName}
              onChange={(e) => setApiName(e.target.value)}
              disabled
              
            />
          </Form.Item>

          <Form.Item label="Description">
            <Input.TextArea
              placeholder="Enter description"
              rows={3}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Item>

          <Form.Item label="Select Object" required>
            <Select
              placeholder="Select Object"
              style={{ width: '100%', marginBottom: '20px' }}
              onChange={handleObjectChange}
              value={selectedObject}
            >
              {objects.map((obj) => (
                <Option key={obj.name} value={obj.name}>
                  {obj.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          

          {selectedObject && (
           <>
           <Form.Item>
            <Checkbox
                checked={isSingleRecord}
                onChange={(e) => setIsSingleRecord(e.target.checked)}
            >
                Fetch Only Single Record
            </Checkbox>
          </Form.Item>
            <FiltersDynamic
              fields={fields}
              filters={filters}
              setFilters={setFilters}
              logic={logic}
              setLogic={setLogic}
              setValueOperator={setValueOperator}
              valueOperator={valueOperator}
              fetchLookupRecords={() => {}}
              fetchLookupRecordsForExistingFilters={() => {}}
            />
           </>

          )}
        </Form>
      )}
    </Drawer>
  );
};

export default GetNodeFlowDrawer;
